import { useQuery, UseQueryOptions } from 'react-query';

import { Guid, DataRoomDocument } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useShowAllDocumentsQuery(
	guid: Guid | undefined,
	options?: Omit<UseQueryOptions<DataRoomDocument[], unknown, DataRoomDocument[]>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Documents.All(guid),
		() => AxiosUtils.getResponseData<DataRoomDocument[]>(api.get(CerebroApiEndpoints.Documents.All(guid))),
		options
	);
}
